import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../../../../app/core/services/auth.service';
import { GlobalName } from '../../../../../../app/core/utils/global-name';
import { LocalStorageService } from '../../../../../../app/core/utils/local-stoarge-service';
import { LayoutStateService } from '../../../../../../app/core/services/layout-state.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  standalone: true,
  imports: [CommonModule, RouterModule]
})
export class HeaderComponent implements OnInit {
  user: any;
  role: any;
  userMenuOpen = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService,
    private lsService: LocalStorageService,
    public state: LayoutStateService
  ) {}

  ngOnInit(): void {
    this.user = this.lsService.get(GlobalName.userName);
    if (this.user?.roles?.length) {
      this.role = this.user.roles[0].name;
    }
  }

  logout(): void {
    this.userMenuOpen = false;
    this.authService.logout().subscribe(
      (res: any) => {
        this.lsService.remove(GlobalName.tokenName);
        this.lsService.remove(GlobalName.refreshTokenName);
        this.lsService.remove(GlobalName.expireIn);
        this.lsService.remove(GlobalName.userName);
        this.lsService.remove(GlobalName.exercice);
        this.lsService.remove(GlobalName.features);
        this.router.navigate(['/login']);
        this.toastr.success('Déconnexion réussie', 'Connexion');
      },
      (err: any) => {
        this.toastr.error('Déconnexion échouée', 'Connexion');
      }
    );
  }
}
